export const PDF_VIEWER_INIT = 'PDF_VIEWER_INIT';
export const PDF_VIEWER_SCROLL = 'PDF_VIEWER_SCROLL';
export const PDF_VIEWER_SET_CURRENT_PAGE = 'PDF_VIEWER_SET_CURRENT_PAGE';



// WEBPACK FOOTER //
// ./src-react/PDFViewer/PDFViewerConstants.jsx